import { useEffect } from "react";

export const SITE_URL = "https://recipefox.site";

const setMeta = (attr, key, value) => {
    let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
    }
    tag.setAttribute("content", value);
};

const setCanonical = (href) => {
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
    }
    link.setAttribute("href", href);
};

/** Per-route title, description, canonical, robots, social tags and JSON-LD. */
export default function useDocumentMeta({ title, description, noIndex = false, path, image, jsonLd } = {}) {
    const ld = jsonLd ? JSON.stringify(jsonLd) : "";
    useEffect(() => {
        const url = `${SITE_URL}${path ?? window.location.pathname}`;
        if (title) {
            document.title = title;
            setMeta("property", "og:title", title);
            setMeta("name", "twitter:title", title);
        }
        if (description) {
            setMeta("name", "description", description);
            setMeta("property", "og:description", description);
            setMeta("name", "twitter:description", description);
        }
        if (image) {
            setMeta("property", "og:image", `${SITE_URL}${image}`);
            setMeta("name", "twitter:image", `${SITE_URL}${image}`);
        }
        setCanonical(url);
        setMeta("property", "og:url", url);
        setMeta("name", "robots", noIndex ? "noindex, follow" : "index, follow, max-image-preview:large");
        let script = null;
        if (ld) {
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.dataset.page = "true";
            script.textContent = ld;
            document.head.appendChild(script);
        }
        return () => { if (script) script.remove(); };
    }, [title, description, noIndex, path, image, ld]);
}
